<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'COMPONENTS.MISSIONS.REPORT.MODAL_CONFIRMATION.TITLE' | translate }}</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="exit()" color="primary">
        <ion-icon name="close"/>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card>
    <ion-card-content>
      <ion-list lines="none">
        <ion-item class="ion-no-padding">
          <ion-label>
            <h2>{{ 'COMPONENTS.MISSIONS.REPORT.MODAL_CONFIRMATION.MESSAGE' | translate }}</h2>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-content>
      <div class="action-button-container">
        <ion-button (click)="answer(true)">
          <ion-icon name="trash" slot="start"/>
          {{ 'COMPONENTS.MISSIONS.REPORT.MODAL_CONFIRMATION.OPTIONS.DISCARD' | translate }}
        </ion-button>
        <ion-button (click)="answer(false)" color="medium">
          {{ 'COMPONENTS.MISSIONS.REPORT.MODAL_CONFIRMATION.OPTIONS.CANCEL' | translate }}
        </ion-button>
      </div>
    </ion-card-content>
  </ion-card>

</ion-content>
